import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvService } from './env.service';
import { Observable } from 'rxjs';
import { editorialListResponse, editorsResponse } from 'src/interface/editorial-board';

@Injectable({
  providedIn: 'root'
})
export class EditorialService {

  constructor(private http: HttpClient, private env: EnvService) { }
  getEditorialMembers(queryParams:{journal_id:string}): Observable<editorsResponse> {
    return this.http.get<editorsResponse>(this.env.siteApiUrl + 'web/editorial-board-list-home', {
        params: queryParams
    });
}
getAllEditorialMembers(queryParams:{journal_id:string}): Observable<editorialListResponse> {
  return this.http.get<editorialListResponse>(this.env.siteApiUrl + 'web/editorial-board-list', {
      params: queryParams
  });
}
}
